<template>
  <div class="flex mb-100">
    <app-avatar :user-id="userId" :size="64" position="is-right"></app-avatar>

    <div class="ml-100">
      <b-upload :disabled="isLoading" v-model="file" @input="updateAvatar">
        <a
          class="display-block is-size-7 mb-50"
          :class="{ 'loading' : isLoading }"
        >
          {{ (user.avatar_url) ? 'Change' : 'Upload' }} Photo
        </a>
      </b-upload>
      <a
        class="display-block is-size-7"
        :class="{ 'loading' : isLoading }"
        @click="removeAvatar"
        v-if="user.avatar_url"
      >
        Remove
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserAvatarForm",
  props: {
    userId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      file: null,
      isLoading: false,
      validationErrors: {}
    }
  },
  computed: {
    user() {
      return this.$store.getters.users.find(u => u.id === this.userId);
    },
  },
  methods: {
    updateAvatar() {
      this.isLoading = true;

      this.$api.users.uploadAvatarImage(this.user.id, this.file)
        .then((response) => {
          this.user.avatar_url = response.data.avatar_url;
        })
        .catch((error) => {
          throw error;
        })
        .finally(() => { this.isLoading = false })
    },
    removeAvatar() {
      this.isLoading = true;

      this.$api.users.deleteAvatarImage(this.user.id)
        .then((response) => {})
        .catch((error) => {
          throw error;
        })
        .finally(() => { this.isLoading = false })
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/variables/variables";

a.loading {
  color: $text-muted;
  cursor: not-allowed;
}
</style>
